import { lazy, Suspense } from 'react';

import { Route } from 'react-router-dom';
import routeUrlProvider, {
  SPLIT_WAITING as SPLIT_WAITING_PATH,
  SPLIT_BILL_BY_ITEM as SPLIT_BILL_BY_ITEM_PATH,
  SPLIT_BILL_EQUALITY as SPLIT_BILL_EQUALITY_PATH,
  SPLIT_BILL_PRE_ITEM,
} from 'constants/route-paths';

import SplitBillWaiting from 'pages/SplitBill/Waiting';
import SplitBillEquality from 'pages/SplitBill/Equality';
import SplitBillPreItems from 'pages/SplitBill/PreItems';
import SplitBillByItem from 'pages/SplitBill/Items';

export default [
  <Route
    exact
    path={routeUrlProvider.getForRoute(SPLIT_BILL_EQUALITY_PATH)}
    render={() => <SplitBillEquality />}
  />,

  <Route
    exact
    path={routeUrlProvider.getForRoute(SPLIT_BILL_PRE_ITEM)}
    render={() => <SplitBillPreItems />}
  />,

  <Route
    exact
    path={routeUrlProvider.getForRoute(SPLIT_BILL_BY_ITEM_PATH)}
    render={() => <SplitBillByItem />}
  />,

  <Route
    exact
    path={routeUrlProvider.getForRoute(SPLIT_WAITING_PATH)}
    render={() => <SplitBillWaiting />}
  />,
];
